<template>
    <div>
        <v-card class="default_card_wm" elevation="0">
            <v-row no-gutters class="d-flex py-3 justify-center">
                <v-col cols="2" class="pr-2">
                    <v-btn-primary
                        dark
                        block
                        @click="editAccountableAccount('')"
                        :disabled="readonly"
                    >
                        Nouveau
                    </v-btn-primary>
                </v-col>
                <v-col cols="2">
                    <v-text-field-filled
                        v-model="accountingPlanName"
                        label="Nom du plan comptable"
                        hide-details
                        outlined
                        density="compact"
                        class="px-1"
                        :disabled="readonly"
                    />
                </v-col>
                <v-col cols="2" class="px-2">
                    <v-select-filled
                        v-model="aaCharacterCount"
                        :items="[6, 7, 8, 9, 10, 11, 12]"
                        label="Nombre de caractères"
                        outlined
                        density="compact"
                        hide-details
                        :disabled="id.length > 0"
                        @update:model-value="updateAANames"
                    />
                </v-col>
                <v-col cols="3" class="pl-2">
                    <AccountableAccountFilter
                        v-model:search="search"
                        v-model:thirdParty="tiersSearch"
                        v-model:vatType="vatTypeSearch"
                        v-model:vatOperation="vatOperationSearch"
                        v-model:transactionType="transactionTypeSearch"
                        v-model:lettering="showLettering"
                        v-model:publish="showPublished"
                        v-model:default="showDefault"
                        @updated-filter="reRenderTable"
                    />
                </v-col>
                <v-col cols="3" class="d-flex justify-center align-center flex-column">
                    <v-switch
                        v-model="showSelected"
                        label="Afficher la sélection"
                        hide-details
                        class="mt-0"
                    />
                </v-col>
                <!-- <v-col cols="1" class="d-flex px-1 justify-end align-center">
                    <v-btn-toggle
                        v-model="displayType"
                        rounded="xl"
                        density="compact"
                        color="ternary"
                    >
                        <v-btn
                            icon="$fa-sitemap"
                            :value="'tree'"
                        />
                        <v-btn
                            icon="$fa-list-ul"
                            :value="'table'"
                        />
                    </v-btn-toggle>
                </v-col> -->
            </v-row>
            <v-row no-gutters class="py-2">
                <v-col cols="12">
                    <!-- <v-window v-model="displayType" touchless>
                        <v-window-item value="tree">
                            <v-row no-gutters class="d-flex py-1 justify-center">
                                <v-col cols="1" class="d-flex justify-start pt-3">
                                    <v-tooltip location="top">
                                        <template #activator="{ props }">
                                            <v-btn-icon
                                                @click.stop="openTree()"
                                                v-bind="props"
                                                :icon="
                                                    expanded ? '$fa-chevron-up' : '$fa-chevron-down'
                                                "
                                                x-small
                                            />
                                        </template>
                                        <span>{{
                                            expanded ? "Réduire la liste" : "Développer la liste"
                                        }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="8">
                                    <v-treeview
                                        ref="accountingPlanTreeview"
                                        :items="items"
                                        item-value="name"
                                        item-title="description"
                                        item-props
                                        v-model:selected="selected"
                                        selectable
                                        select-strategy="classic"
                                        :search="search"
                                        :custom-filter="treeFilter"
                                        v-model:opened="open"
                                        collapse-icon="$keyboard_arrow_down"
                                        expand-icon="$keyboard_arrow_right"
                                        @update:selected="selectedItem"
                                    >
                                        <template v-slot:title="{ item }">
                                            <span>{{ item.name + " - " + item.description }}</span>
                                        </template>
                                        <template v-slot:prepend="{ item }">
                                            <v-icon
                                                :icon="selectIcon(item.name)"
                                                v-if="item.parent"
                                                color="green"
                                                class="icon"
                                            />
                                        </template>
                                        <template #item="{ props }">
                                            <v-treeview-item
                                                :value="props.value"
                                                :title="props.value + ' - ' + props.title"
                                                :disabled="props.disabled"
                                            >
                                                <template #prepend="{ isSelected }">
                                                    <v-checkbox
                                                        class="pl-2 pr-4"
                                                        color="primary"
                                                        density="compact"
                                                        small
                                                        hide-details="auto"
                                                        :value="isSelected"
                                                    />
                                                </template>
                                                <template v-slot:append="{ isSelected }">
                                                    <template v-if="isEditableLeaf(props)">
                                                        <span class="mt-1 text-center">
                                                            {{ complementInfo(props, true).join(" | ") }}
                                                        </span>
                                                        <v-btn-icon
                                                            icon="$oss-edit "
                                                            :disabled="!isSelected"
                                                            size="small"
                                                            @click="
                                                                editAccountableAccount(props.name)
                                                            "
                                                            v-if="!readonly"
                                                        />
                                                    </template>
                                                </template>
                                            </v-treeview-item>
                                        </template>
                                    </v-treeview>
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item value="table"> -->
                    <v-row class="d-flex justify-center">
                        <v-col cols="11">
                            <v-data-table
                                :key="tableKey"
                                :headers="plantHeaders"
                                :items="accountingTable"
                                :fixed-header="true"
                                :custom-filter="descriptionFilter"
                                class="table elevation-0"
                                :group-by="[{ key: 'digit', order: 'asc' }]"
                                :items-per-page="-1"
                                hide-default-footer
                                style="max-height: calc(100vh - 350px); overflow-y: auto"
                            >
                                <template
                                    v-slot:group-header="{
                                        item,
                                        columns,
                                        isGroupOpen,
                                        toggleGroup,
                                        index,
                                    }"
                                >
                                    <tr :key="`group_${item.value}`">
                                        <td>
                                            <v-btn-icon
                                                :ref="`toggle_btn_${item.value}`"
                                                @click="
                                                    toggleGroup(item);
                                                    expandedGroups[parseInt(item.value) - 1] =
                                                        isGroupOpen(item);
                                                "
                                                :icon="
                                                    isGroupOpen(item)
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                "
                                                size="medium"
                                                class="ml-1"
                                            />
                                        </td>
                                        <td>
                                            <v-btn-icon
                                                @click="toggleSelectGroup(item.value)"
                                                hide-details
                                                :icon="getGroupState(item.value)"
                                                color="primary"
                                                :disabled="readonly"
                                            />
                                        </td>
                                        <td>
                                            <span class="text-body-1">
                                                {{ item.value }}
                                            </span>
                                            <v-icon
                                                :icon="selectIcon(item.value.toString())"
                                                color="green"
                                                class="ml-3"
                                                size="large"
                                            />
                                        </td>
                                        <td>
                                            <span class="text-body-1">
                                                {{
                                                    $t(
                                                        "accountableAccount." +
                                                            getAccountableAccountType(item.value),
                                                    )
                                                }}
                                            </span>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </template>
                                <template v-slot:header.data-table-group>
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                v-bind="props"
                                                :icon="
                                                    toggleOpenAll
                                                        ? '$fa-caret-down'
                                                        : '$fa-caret-up'
                                                "
                                                @click="openAllTable"
                                                color="secondary"
                                                density="compact"
                                                :disabled="disableOpenAll"
                                            />
                                        </template>
                                        <span>{{
                                            toggleOpenAll
                                                ? "Ouvrir les groupes"
                                                : "Fermer les groupes"
                                        }}</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:item="props">
                                    <tr>
                                        <td></td>
                                        <td style="justify-items: center">
                                            <v-checkbox
                                                color="primary"
                                                density="compact"
                                                small
                                                :disabled="props.item.disabled"
                                                hide-details="auto"
                                                @click="handleRowClick($event, props.item)"
                                                @update:model-value="updateSelected(props.item)"
                                                :readonly="readonly"
                                                :model-value="selected.includes(props.item.name)"
                                            />
                                        </td>
                                        <td>
                                            {{ props.item.name }}
                                        </td>
                                        <td class="text-left">
                                            {{ props.item.description }}
                                        </td>
                                        <td class="text-left">
                                            <template
                                                v-if="
                                                    !props.item.children.length && props.item.isLeaf //&&
                                                    // !props.item.name.startsWith('6') &&
                                                    // !props.item.name.startsWith('7')
                                                "
                                            >
                                                <v-chip
                                                    v-for="info in complementInfo(
                                                        props.item,
                                                        false,
                                                    )"
                                                    :key="props.item.name + '-' + info"
                                                    label
                                                    class="ma-1"
                                                    size="x-small"
                                                    >{{ info }}</v-chip
                                                >
                                            </template>
                                        </td>
                                        <td>
                                            <template
                                                v-if="
                                                    !props.item.children.length && props.item.isLeaf //&&
                                                    // !props.item.name.startsWith('6') &&
                                                    // !props.item.name.startsWith('7')
                                                "
                                            >
                                                <span class="mt-1 text-center">
                                                    {{ props.item.lettering ? "À lettrer" : "" }}
                                                </span>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="isEditableLeaf(props.item)">
                                                <v-btn-icon
                                                    v-if="!readonly"
                                                    icon="$oss-edit"
                                                    size="small"
                                                    :disabled="!selected.includes(props.item.name)"
                                                    @click="editAccountableAccount(props.item.name)"
                                                />
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <!-- </v-window-item>
                    </v-window> -->
                </v-col>
            </v-row>
        </v-card>
        <AccountableAccountEdition
            v-model="editAccountDialog"
            :accountableAccount="accountableAccountEdition"
            :existingAccountableAccounts="allLeaves"
            :authorizeExistingAAModification="true"
            :aaCharacterCount="aaCharacterCount"
            :fromParentTable="true"
            @validate="upsertPattern"
            v-if="editAccountDialog"
        >
        </AccountableAccountEdition>
    </div>
</template>

<script lang="ts">
import { Component, Ref, Vue, Watch, toNative } from "vue-facing-decorator";
import { Apollo } from "../../decorators";
import { User } from "../../store/store";

import ACCOUNTABLE_ACCOUNT_TABLE from "../../graphql/accountableAccount/AccountableAccountTable.gql";
import UPSERT_ACCOUNTING_PLAN from "../../graphql/accountableAccount/upsertAccountingPlan.gql";

import {
    getAccountableAccountType,
    getMandatoryAccountableAccounts,
} from "../../../../backend/src/common/accountableAccount/accountableAccountServices";
import accountingPlanFolder from "./accountingPlanFolder.json";

import OssDataTable from "../ossComponents/ossDataTable2.vue";
import AccountableAccountEdition from "./AccountableAccountEdition.vue";
import AccountableAccountFilter from "./AccountableAccountFilter.vue";

import { AANode } from "./AccountableAccountNode";
import { getAccountableAccountComplementInfo } from "@/services/accountableAccountServices";

type Header = {
    title: string;
    value: string;
    sortable?: boolean;
    align?: "start" | "center" | "end";
    width?: string;
    //@ts-expect-error aze
    filter?: FilterFunction;
};

@Component({
    components: {
        AccountableAccountEdition,
        OssDataTable,
        AccountableAccountFilter,
    },
    emits: ["onValidChanged", "setScope","scopeReadonly"],
})
export class AccountingPlanEditor extends Vue {
    @Ref("accountingPlanTreeview") accountingPlanTreeview: any;
    @Ref() toggle_btn_1!: HTMLElement;
    @Ref() toggle_btn_2!: HTMLElement;
    @Ref() toggle_btn_3!: HTMLElement;
    @Ref() toggle_btn_4!: HTMLElement;
    @Ref() toggle_btn_5!: HTMLElement;
    @Ref() toggle_btn_6!: HTMLElement;
    @Ref() toggle_btn_7!: HTMLElement;

    selected = [];
    items = [];
    expandedGroups = [false, false, false, false, false, false, false];
    selectedGroups = [false, false, false, false, false, false, false];
    tableKey = 0;

    //     items2 = [
    //     {
    //       name: 1,
    //       description: 'Applications :',
    //       disabled: true,
    //       parent: true,
    //       children: [
    //         { name: 2, description: 'Calendar : app' },
    //         { name: 3, description: 'Chrome : app' },
    //         { name: 4, description: 'Webstorm : app' },
    //       ],
    //     },
    //     {
    //       name: 5,
    //       description: 'Documents :',
    //       parent: true,
    //       children: [
    //         {
    //           name: 6,
    //           description: 'vuetify :',
    //           children: [
    //             {
    //               name: 7,
    //               description: 'src :',
    //               disabled: true,
    //               children: [
    //                 { name: 8, description: 'index : ts' },
    //                 { name: 9, description: 'bootstrap : ts' },
    //               ],
    //             },
    //           ],
    //         },
    //         {
    //           name: 10,
    //           description: 'material2 :',
    //           children: [
    //             {
    //               name: 11,
    //               description: 'src :',
    //               children: [
    //                 { name: 12, description: 'v-btn : ts' },
    //                 { name: 13, description: 'v-card : ts' },
    //                 { name: 14, description: 'v-window : ts' },
    //               ],
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //     {
    //       name: 15,
    //       parent: true,
    //       description: 'Downloads :',
    //       children: [
    //         { name: 16, description: 'October : pdf', disabled: true },
    //         { name: 17, description: 'November : pdf', disabled: true },
    //         { name: 18, description: 'Tutorial : html', disabled: true },
    //       ],
    //     },
    //     {
    //       name: 19,
    //       parent: true,
    //       description: 'Videos :',
    //       children: [
    //         {
    //           name: 20,
    //           description: 'Tutorials :',
    //           children: [
    //             { name: 21, description: 'Basic layouts : mp4' },
    //             { name: 22, description: 'Advanced techniques : mp4' },
    //             { name: 23, description: 'All about app : dir' },
    //           ],
    //         },
    //         { name: 24, description: 'Intro : mov', disabled: true },
    //         { name: 25, description: 'Conference introduction : avi' },
    //       ],
    //     },
    //   ]

    treeLoading = true;

    accountingPlan: AANode[] = [];
    accountingTable = [];

    loaded = false;

    readonly = false;

    upsertValid = false;

    accountingRoot = {};
    accountingRootOpen = [];

    search = "";
    tiersSearch = "";
    vatTypeSearch = "";
    vatOperationSearch = "";
    transactionTypeSearch = "";
    expanded = false;
    showSelected = false;
    showLettering = false;
    showPublished = false;
    showDefault = false;
    open = [];

    aaCharacterCount: number = 6;

    scopeId_: string = "";

    displayType = "table";

    editAccountDialog = false;
    accountableAccountEdition: AANode = null;

    plantHeaders: Header[] = [
        { title: "", value: "empty", sortable: false, width: "5%" },
        {
            title: "Numéro",
            value: "name",
            sortable: false,
            filter: this.selectedFilter,
            width: "10%",
        },
        {
            title: "Description",
            value: "displayDescription",
            sortable: false,
            width: "50%",
        },
        {
            title: "Complément",
            value: "complement",
            width: "15%",
            align: "center",
            sortable: false,
        },
        { title: "Lettrage", value: "lettering", width: "10%", align: "center", sortable: false },
        { title: "Éditer", value: "edit", sortable: false, width: "5%" },
    ];

    propagation: boolean = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.id;
        }
        return undefined;
    }

    get accountingFirm() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.accountingFirm;
        }
        return undefined;
    }

    get accountingCompanyId() {
        return this.currentUser.company.id;
    }

    get clientCompaniesIds() {
        const result = [];
        for (const company of this.currentUser.allAvailableCompanies) {
            result.push(company.id);
        }
        return result;
    }

    get isPlanValid() {
        if (this.accountingPlanName && this.selected.length) {
            return true;
        }
        return false;
    }

    @Watch("isPlanValid")
    onIsPlanValidChanged() {
        this.$emit("onValidChanged", this.isPlanValid);
    }

    get id() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        }
        return "";
    }

    get importedData() {
        if (this.$store?.state?.importPlanData) {
            const importedPlan = this.$store.state.importPlanData;
            if (importedPlan["accountingPlan"] || importedPlan["accountingTree"]) {
                return importedPlan;
            }
        }

        return null;
    }

    get idToDuplicate() {
        if (this.$route.params.idToDuplicate) {
            return this.$route.params.idToDuplicate;
        }
        return "";
    }

    get mandatoryAccountableAccounts() {
        return getMandatoryAccountableAccounts();
    }

    beforeMount() {
        this.treeFilter = this.treeFilter.bind(this);
        this.descriptionFilter = this.descriptionFilter.bind(this);
        // debugger;
        this.accountingRoot = Object.fromEntries(
            Object.entries(accountingPlanFolder).filter(([key, value]) => !key.startsWith("8")),
        );
        this.accountingRootOpen = Object.keys(this.accountingRoot).map((x) => x + " ");
        this.treeLoading = true;
        if (this.importedData && this.importedData["accountingTree"]?.length) {
            this.accountingPlan = this.buildTree(
                this.accountingRoot,
                this.importedData["accountingTree"],
            );
            // this.buildTree2(this.accountingRoot,this.importedData["accountingTree"])
            this.buildTable();
            // this.selected = this.selectFixedAccounts(this.importedData["accountingTree"]).concat(
            //     this.importedData["accountingPlan"].map((aa) => aa.name)
            // );
            this.aaCharacterCount = this.importedData["aaCharacterCount"] || 6;
            this.treeLoading = false;
        }
        if (!this.id && !this.idToDuplicate) {
            this.loaded = true;
        }
        if (this.id) {
            this.showSelected = true;
        }
    }

    isReadOnly(accountingCompanyId, accountingCompanyOwnerId) {
        // if modified also change isReadOnly used with other components using <Scope>
        if (this.idToDuplicate) {
            this.readonly = false;
            return;
        }
        if (
            accountingCompanyId == undefined &&
            accountingCompanyOwnerId !== this.accountingCompanyId
        ) {
            this.readonly = true;
        }
        this.$emit("scopeReadonly",this.readonly)
    }

    fixAccount(name) {
        if (this.mandatoryAccountableAccounts.find((faa) => name.startsWith(faa))) {
            return true;
        }
        return false;
    }

    selectFixedAccounts(accountableAccounts) {
        return accountableAccounts.filter((aa) => this.fixAccount(aa.name)).map((el) => el.name);
    }

    selectIcon(name) {
        const digit = name[0];
        switch (digit) {
            case "1": {
                return "$business";
            }
            case "2": {
                return "$business-center";
            }
            case "3": {
                return "$storage";
            }
            case "4": {
                return "$fa-university";
            }
            case "5": {
                return "$euro";
            }
            case "6": {
                return "$fa-credit-card";
            }
            case "7": {
                return "$shopping-cart";
            }
            case "8": {
                return "$fa-credit-card";
            }
        }
        return "$label";
    }

    getAccountableAccountType(aaName) {
        return getAccountableAccountType(aaName.toString());
    }

    // buildTree2(data, accounts) {
    //     const tree = [];
    //     const entries = Object.entries(data).slice(0, 100);

    //     const createNode = (key, description, root = false) => ({
    //         id: "",
    //         name: key + " ",
    //         description: description || `Root ${key}`,
    //         children: [],
    //         parent: root,
    //         disabled: this.readonly,
    //     });

    //     const accountMap = accounts.reduce((map, account) => {
    //         const prefix = account.name.substring(0, 3);
    //         if (!map[prefix]) map[prefix] = [];
    //         map[prefix].push({
    //             name: account.name,
    //             id: account.id,
    //             // digit: account.name[0],
    //             description: account.description,
    //             disabled: this.fixAccount(account.name) || this.readonly,
    //             lettering: account.lettering,
    //             detailedCarryForward: account.detailedCarryForward,
    //             vatRate: account.vatRate,
    //             vatType: account.vatType,
    //             vatOperationType: account.vatOperationType,
    //             type: account.type,
    //             user: account.user,
    //             bankAccount: account.bankAccount,
    //             thirdPartyCompany: account.thirdPartyCompany,
    //             isLeaf: true,
    //         });
    //         return map;
    //     }, {});

    //     debugger;
    //     const processEntries = (entries, parentNode) => {
    //         entries.forEach(([key, description]) => {
    //             const node = createNode(key, description);
    //             parentNode.children.push(node);

    //             const accountsForNode = accountMap[key] || [];
    //             accountsForNode.forEach((child) => node.children.push(child));

    //             if (key.length < 3) {
    //                 // If it's 1 or 2 digit, process the next level
    //                 const nextLevelEntries = Object.entries(data).filter(
    //                     ([entryKey]) => entryKey.startsWith(key) && entryKey !== key,
    //                 );
    //                 processEntries(nextLevelEntries, node);
    //             }
    //         });
    //     };

    //     const oneDigitEntries = entries.filter(([key]) => key.length === 1);
    //     oneDigitEntries.forEach(([key, description]) => {
    //         const rootNode = createNode(key, description, true);
    //         tree.push(rootNode);

    //         const twoDigitEntries = entries.filter(
    //             ([key2]) => key2.startsWith(key) && key2.length === 2,
    //         );
    //         processEntries(twoDigitEntries, rootNode);
    //     });
    //     debugger;
    //     this.items = tree;
    // }

    buildTree(data, accounts): AANode[] {
        const tree: AANode[] = [];
        const nodeMap = {};

        const addToTree = (key, description, parentKey = null) => {
            const parentNode = parentKey ? nodeMap[parentKey] : null;
            const disabled = this.fixAccount(key) || this.readonly;
            const node = new AANode(
                key + " ",
                "",
                description,
                "",
                disabled,
                false,
                false,
                null,
                null,
                null,
                "",
                false,
                false,
                false,
                null,
                null,
                null,
                false,
            ); //Add space to AANode name

            if (parentNode) {
                parentNode.addChild(node);
            } else {
                tree.push(node);
            }

            nodeMap[key] = node;
            return node;
        };
        const entries = Object.entries(data);
        for (let i = 0; i < entries.length; i++) {
            const [key, description] = entries[i];

            if (/^\d$/.test(key) && key.length === 1) {
                addToTree(key, description);
            } else if (/^\d{2}$/.test(key) && key.length === 2) {
                const parent = addToTree(key, description, key[0]);
                const hasSubEntries = entries.some(
                    ([nameKey]) => nameKey.startsWith(key) && nameKey !== key,
                );
                const children = accounts
                    .filter((account) => {
                        return account.name.startsWith(key) && 
                            ( 
                                !hasSubEntries || 
                                !entries.some(([entryKey]) => entryKey === account.name.slice(0, 3)) 
                            )
                        })
                    .map(
                        (account) =>
                            new AANode(
                                account.name,
                                account.id,
                                account.description,
                                account.shortDescription,
                                this.fixAccount(account.name) || this.readonly,
                                account.lettering,
                                account.detailedCarryForward,
                                account.vatRate,
                                account.vatType,
                                account.vatOperationType,
                                account.type,
                                account.user,
                                account.bankAccount,
                                account.thirdPartyCompany,
                                account.transactionType,
                                account.default,
                                account.paidAndUncashed,
                                account.publish,
                            ),
                    );

                children.forEach((child) => parent.addChild(child));

            } else if (/^\d{3}$/.test(key) && key.length === 3) {
                const parentKey = key.slice(0, 2);
                const parent = addToTree(key, description, parentKey);

                const children = accounts
                    .filter((account) => account.name.startsWith(key))
                    .map(
                        (account) =>
                            new AANode(
                                account.name,
                                account.id,
                                account.description,
                                account.shortDescription,
                                this.fixAccount(account.name) || this.readonly,
                                account.lettering,
                                account.detailedCarryForward,
                                account.vatRate,
                                account.vatType,
                                account.vatOperationType,
                                account.type,
                                account.user,
                                account.bankAccount,
                                account.thirdPartyCompany,
                                account.transactionType,
                                account.default,
                                account.paidAndUncashed,
                                account.publish,
                            ),
                    );

                children.forEach((child) => parent.addChild(child));
            }
        }

        return tree;
    }

    buildTable() {
        const filterLeaves = (node) => {
            if (!node.children.length && node.isLeaf) {
                this.accountingTable.push(node);
            } else {
                for (const child of node.children) {
                    filterLeaves(child);
                }
            }
        };

        for (const root of this.accountingPlan) {
            filterLeaves(root);
        }
    }

    get selectedLeaves() {
        const leaves = [];
        // const self = this;
        const filterLeaves = (node) => {
            if (!node.children.length && node.isLeaf && this.selected.includes(node.name)) {
                leaves.push(node);
                // leaves.push({
                //     id: node.id,
                //     name: node.name,
                //     type: node.type || self.getAccountableAccountType(node.name),
                //     description: node.description,
                //     shortDescription: node.shortDescription,
                //     lettering: node.lettering,
                //     detailedCarryForward: node.detailedCarryForward,
                //     vatRate: node.vatRate,
                //     vatType: node.vatType,
                //     vatOperationType: node.vatOperationType,
                //     user: node.user,
                //     thirdPartyCompany: node.thirdPartyCompany,
                //     bankAccount: node.bankAccount
                // });
            } else {
                for (const child of node.children) {
                    filterLeaves(child);
                }
            }
        };

        for (const root of this.accountingPlan) {
            filterLeaves(root);
        }

        return leaves;
    }

    get allLeaves() {
        const leaves = [];

        const filterLeaves = (node) => {
            if (!node.children.length && node.isLeaf) {
                leaves.push(node);
                // {
                // id: node.id,
                // name: node.name,
                // type: node.type || this.getAccountableAccountType(node.name),
                // description: node.description,
                // shortDescription: node.shortDescription,
                // lettering: node.lettering,
                // detailedCarryForward: node.detailedCarryForward,
                // vatRate: node.vatRate,
                // vatType: node.vatType,
                // vatOperationType: node.vatOperationType,
                // user: node.user,
                // thirdPartyCompany: node.thirdPartyCompany,
                // bankAccount: node.bankAccount
                // }
                // );
            } else {
                for (const child of node.children) {
                    filterLeaves(child);
                }
            }
        };

        for (const root of this.accountingPlan) {
            filterLeaves(root);
        }

        return leaves;
    }

    openTreeSearch(searchWord, parameter) {
        const itemsWithChildrenAndDescription = [];

        const filterItems = (node) => {
            if (!node.children.length && node[parameter].toLowerCase().includes(searchWord)) {
                itemsWithChildrenAndDescription.push(node.name.substring(0, 3) + " ");
                itemsWithChildrenAndDescription.push(node.name.substring(0, 2) + " ");
                itemsWithChildrenAndDescription.push(node.name[0] + " ");
            } else {
                for (const child of node.children) {
                    filterItems(child);
                }
            }
        };

        for (const root of this.accountingPlan) {
            filterItems(root);
        }

        return itemsWithChildrenAndDescription;
    }

    openTree() {
        this.expanded = !this.expanded;
        // this.open = [1,2,3,4,5,6,7]
        if (this.expanded) {
            if (!this.search?.length || this.search === " ") {
                // this.$refs.accountingPlanTreeview.updateAll()
                this.open = this.accountingRootOpen;
            } else {
                const caseSearch = this.search.toLowerCase();
                if (/^\d+$/.test(caseSearch)) {
                    this.open = this.openTreeSearch(caseSearch, "name");
                } else {
                    this.open = this.openTreeSearch(caseSearch, "description");
                }
            }
        } else {
            this.open = [];
        }
    }

    updateLettering() {
        const stack = [...this.accountingPlan];

        while (stack.length > 0) {
            const node = stack.pop();

            if (!node.children.length && node.lettering) {
                if (!this.selected.some((selectedItem) => selectedItem === node.name)) {
                    node.lettering = false;
                }
            } else {
                stack.push(...node.children);
            }
        }
    }

    selectedItem() {
        // this.updateLettering();
        //   console.log('checkbox clicked', e)
        console.log("selected list (", this.selected.length, "): ", this.selected);
    }

    treeFilter = function (value, search, item) {
        if (this.displayType === "tree") {
            if (this.showSelected) {
                return (
                    this.selected.includes(item.value) &&
                    (value.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
                        item.value.toLowerCase().indexOf(search.toLowerCase()) > -1)
                );
            }
        }
        return (
            value.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
            item.value.toLowerCase().indexOf(search.toLowerCase()) > -1
        );
    };

    descriptionFilter = function (value, search, item) {
        if (this.displayType === "tree") {
            return true;
        }
        const nameMatch = item.raw.name?.includes(this.search);
        const descMatch = item.raw.description?.toLowerCase().includes(this.search.toLowerCase());
        const transactionMatch = this.transactionTypeSearch
            ? item.raw.transactionType === this.transactionTypeSearch
            : true;
        const vatTypeMatch = this.vatTypeSearch ? item.raw.vatType === this.vatTypeSearch : true;
        const vatOpMatch = this.vatOperationSearch
            ? item.raw.vatOperationType === this.vatOperationSearch
            : true;
        const tiersMatch = this.tiersSearch ? Boolean(item.raw[this.tiersSearch]) : true;
        const publishMatch = this.showPublished ? Boolean(item.raw.publish) : true;
        const letterinMatch = this.showLettering ? Boolean(item.raw.lettering) : true;
        const defaultMatch = this.showDefault ? Boolean(item.raw.default) : true;

        return (
            (nameMatch || descMatch) &&
            tiersMatch &&
            vatOpMatch &&
            vatTypeMatch &&
            transactionMatch &&
            publishMatch &&
            letterinMatch &&
            defaultMatch
        );
    };

    selectedFilter(value) {
        if (!this.showSelected || this.displayType === "tree") {
            return true;
        }
        return this.selected.includes(value);
    }

    complementInfo(item, lettering) {
        return getAccountableAccountComplementInfo(item, lettering);
    }

    updateSelected(item) {
        // const selIndex = this.selected.findIndex((aa) => aa === item.name);
        // if (selIndex > -1) {
        //     this.selected.splice(selIndex, 1);
        // } else {
        //     this.selected.push(item.name);
        // }
        // this.updateLettering();
    }

    getGroupState(startDigit) {
        const filteredItems = this.accountingTable.filter((item) =>
            item.name.startsWith(startDigit),
        );
        if (filteredItems.every((item) => this.selected.includes(item.name))) {
            return "$checkboxOn";
        } else if (filteredItems.every((item) => !this.selected.includes(item.name))) {
            return "$checkboxOff";
        }
        return "$checkboxIndeterminate";
    }

    toggleSelectGroup(startDigit) {
        const index = parseInt(startDigit);
        const filteredItems = this.accountingTable.filter((item) =>
            item.name.startsWith(startDigit),
        );
        if (!this.selectedGroups[index]) {
            filteredItems.forEach((item) => {
                if (!this.selected.includes(item.name)) {
                    this.selected.push(item.name);
                }
            });
        } else {
            const nonMandatoryItems = filteredItems.filter((item) => item.disabled !== true);
            nonMandatoryItems.forEach((item) => {
                const index = this.selected.findIndex((aa) => aa === item.name);
                if (index !== -1) {
                    this.selected.splice(index, 1);
                }
            });
        }
        this.selectedGroups[index] = !this.selectedGroups[index];
    }

    reRenderTable() {
        // Increment key to force render, otherwise data gets mixed
        this.tableKey += 1;
    }

    disableOpenAll = false;
    toggleOpenAll = true;
    openAllTable() {
        this.disableOpenAll = true;
        for (let i = 0; i < 7; i++) {
            const btnRef = this[`toggle_btn_${i + 1}`];
            if (btnRef && btnRef.$el && this.toggleOpenAll === !this.expandedGroups[i]) {
                setTimeout(() => {
                    btnRef.$el.click();
                }, 100);
            }
        }
        setTimeout(() => {
            this.disableOpenAll = false;
            this.toggleOpenAll = !this.toggleOpenAll;
        }, 2000);
    }

    // if(this.search) {
    //     setTimeout(() => {
    //         for(let i=1; i <= 7; i++) {
    //             const btnRef = this[`toggle_btn_${i}`]
    //             if (btnRef && btnRef.$el) {
    //                 btnRef.$el.click();
    //             }
    //         }
    //     }, 500);
    // }

    lastSelectedIndex = null;
    handleRowClick(event, item) {
        const realIndex = this.accountingTable.findIndex((aa) => aa.name === item.name);
        if (event.shiftKey && this.lastSelectedIndex !== null) {
            const start = Math.min(this.lastSelectedIndex, realIndex);
            const end = Math.max(this.lastSelectedIndex, realIndex);
            for (let i = start; i <= end; i++) {
                const item = this.accountingTable[i];
                if (!this.selected.includes(item.name)) {
                    this.selected.push(item.name);
                }
            }
        } else {
            const selIndex = this.selected.findIndex((aa) => aa === item.name);
            if (selIndex === -1) {
                this.selected.push(item.name);
            } else {
                this.selected.splice(selIndex, 1);
            }
            this.lastSelectedIndex = realIndex;
        }
        this.updateLettering();
    }

    @Apollo({
        query: ACCOUNTABLE_ACCOUNT_TABLE,
        variables() {
            return {
                id: this.id || this.idToDuplicate,
            };
        },
        skip() {
            return !!this.importedData;
        },
        fetchPolicy: "network-only",
        result({ data, loading }: any) {
            if (!loading) {
                if (data?.accountingPlan) {
                    // debugger
                    this.treeLoading = true;
                    if (data.accountingPlan.accountingPlan) {
                        const plan = data.accountingPlan.accountingPlan;
                        this.isReadOnly(
                            plan.companyScope.accountingCompanyId,
                            plan.companyScope.accountingCompanyOwnerId,
                        );
                    }
                    const tree = data.accountingPlan.accountingTree;
                    // this.buildTree2(this.accountingRoot, tree);
                    this.accountingPlan = this.buildTree(this.accountingRoot, tree);
                    this.buildTable();
                    if (data.accountingPlan.accountingPlan) {
                        const plan = data.accountingPlan.accountingPlan;
                        this.aaCharacterCount = plan.aaCharacterCount;
                        this.accountingPlanName = this.idToDuplicate ? "" : plan.name;
                        this.selected = this.selectFixedAccounts(tree).concat(
                            plan.accountableAccounts.map((aa) => aa.name),
                        );
                        const scope = this.idToDuplicate ? null : plan.companyScope;
                        this.$emit("setScope", scope);
                    } else {
                        this.selected = this.selectFixedAccounts(tree);
                    }
                    this.treeLoading = false;
                    this.loaded = true;
                }
            }
        },
    })
    accountingPlanName = "";

    async upsertAccountingPlan(scopeId: string) {
        const selectedLeaves = [];
        for (const leaf of this.selectedLeaves) {
            const dbLeaf = {};
            for (const key in leaf) {
                if (!key) {
                    continue;
                }
                // if (key === "parent" || key === "children" || key === "id") {
                if (key === "parent" || key === "children") {
                    continue;
                }
                dbLeaf[key] = leaf[key];
            }
            selectedLeaves.push(dbLeaf);
        }
        if (this.isPlanValid) {
            const result = await this.$apollo.mutate({
                mutation: UPSERT_ACCOUNTING_PLAN,
                variables: {
                    id: this.id || "",
                    name: this.accountingPlanName,
                    aaCharacterCount: this.aaCharacterCount,
                    companyScopeId: scopeId,
                    accountableAccounts: selectedLeaves,
                    propagation: this.propagation,
                },
            });
            return result;
        }
        return null;
    }

    addLeaf(tree, path, leaf) {
        let currentNode = tree;
        for (const step of path) {
            if (currentNode[step]) {
                currentNode = currentNode[step];
            } else if (
                currentNode.children.find((ch) => ch.name === step || ch.name === step + " ")
            ) {
                currentNode = currentNode.children.find(
                    (ch) => ch.name === step || ch.name === step + " ",
                );
            } else {
                return null;
            }
        }
        // leaf.name = leaf.name
        leaf.type = getAccountableAccountType(leaf.name);
        currentNode.addChild(leaf);

        return leaf;
    }

    upsertPattern(data: AANode, propagation: boolean = false) {
        // this.accountableAccountEdition = data
        // let existingName:boolean = false
        // if(!data.id) {
        let foundNode;
        debugger;
        for (const root of this.accountingPlan) {
            foundNode = root.findNodeByName(data.name);
            if (foundNode) {
                foundNode.setData(data);
                break;
            }
        }
        if (!foundNode) {
            const newName = this.accountableAccountEdition.name;
            const root = (parseInt(newName[0]) - 1).toString();
            const path = [root, newName.slice(0, 2), newName.slice(0, 3)];
            this.addLeaf(this.accountingPlan, path, this.accountableAccountEdition);
            this.selected.push(newName);

            const insertIndex = this.accountingTable.findIndex(
                (item) => parseInt(item.name) > parseInt(newName),
            );
            const finalIndex = insertIndex !== -1 ? insertIndex : this.accountingTable.length;
            this.accountingTable.splice(finalIndex, 0, this.accountableAccountEdition);

            this.editAccountDialog = false;
            this.accountableAccountEdition = null;
        }

        this.propagation = propagation;
    }

    isEditableLeaf(item) {
        if (
            !item.children?.length &&
            item.isLeaf // &&
            // !item.name.startsWith("6") &&
            // !(item.name.startsWith("7") && !item.name.startsWith("70"))
        ) {
            return true;
        }
        return false;
    }

    editAccountableAccount(aaName) {
        let createNode = true;
        if (aaName) {
            for (const root of this.accountingPlan) {
                const foundNode: AANode = root.findNodeByName(aaName);
                if (foundNode) {
                    this.accountableAccountEdition = new AANode(
                        foundNode.name,
                        foundNode.id,
                        foundNode.description,
                        foundNode.shortDescription,
                        foundNode.disabled,
                        foundNode.lettering,
                        foundNode.detailedCarryForward,
                        foundNode.vatRate,
                        foundNode.vatType,
                        foundNode.vatOperationType,
                        foundNode.type,
                        foundNode.user,
                        foundNode.bankAccount,
                        foundNode.thirdPartyCompany,
                        foundNode.transactionType,
                        foundNode.default,
                        foundNode.paidAndUncashed,
                        foundNode.publish,
                    );
                    createNode = false;
                    break;
                }
            }
        }
        if (createNode) {
            this.accountableAccountEdition = new AANode(
                "",
                "",
                "",
                "",
                false,
                false,
                false,
                null,
                null,
                null,
                "",
                false,
                false,
                false,
                null,
                null,
                null,
                false,
            );
        }
        this.editAccountDialog = true;
    }

    updateAANames() {
        const previousDicoAAs = {};
        for (const aaNode of this.allLeaves) {
            previousDicoAAs[aaNode.name] = aaNode;
        }
        const selected = this.selected;
        let updateSelected = false;
        for (const node of this.allLeaves) {
            if (!node.children.length && node.isLeaf) {
                const oldName = node.name;
                let newName = node.name;
                if (node.name.length > 5) {
                    if (node.name.length < this.aaCharacterCount) {
                        newName = node.name.padEnd(this.aaCharacterCount, "0");
                    } else if (node.name.length > this.aaCharacterCount) {
                        newName = node.name.slice(0, this.aaCharacterCount);
                    }
                }
                if (!previousDicoAAs[newName]) {
                    const selIndex = selected.findIndex((aa) => aa === oldName);
                    if (selIndex >= 0) {
                        selected[selIndex] = newName;
                        updateSelected = true;
                    }
                    node.name = newName;
                } else {
                    console.log("existing name", newName);
                }
            }
        }
        if (updateSelected) {
            this.selected = selected;
        }

        // const stack = [...this.accountingPlan];
        // const self = this
        // while (stack.length > 0) {
        //     const node = stack.pop();
        //     if (!node.children.length && node.isLeaf) {
        //         const oldName = node.name
        //         let newName = node.name
        //         if(node.name.length > 5) {
        //             if (node.name.length < self.aaCharacterCount) {
        //                 newName = node.name.padEnd(self.aaCharacterCount,"0")
        //                 node.name = newName
        //             }
        //             else if(node.name.length > self.aaCharacterCount) {
        //                 newName = node.name.slice(0, self.aaCharacterCount)
        //                 node.name = newName
        //             }
        //         }
        //         // const selIndex = this.selected.findIndex(aa => aa === oldName)
        //         // if(selIndex > -1) {
        //         //     this.selected[selIndex] = newName
        //         // }
        //     } else {
        //         stack.push(...node.children);
        //     }
        // }
        // debugger
    }
}

export default toNative(AccountingPlanEditor);
</script>

<style scoped>
.v-list-item.v-list-item--disabled {
    pointer-events: auto;
    opacity: 1;
}
.v-list-item.v-list-item--disabled:hover {
    pointer-events: auto;
    cursor: pointer;
    background-color: #ededed;
}
.v-list-item:hover {
    background-color: #ededed !important;
}

.v-list-item--disabled .v-selection-control {
    pointer-events: none;
    opacity: 0.7;
}

.v-list-item-action .v-btn__content {
    color: #262626;
}
</style>
